// src/services/authService.ts
import { getAuth } from 'firebase/auth';
import logger from 'src/logger';
export const getValidToken = async () => {
  const auth = getAuth();
  const user = auth.currentUser;
  
  if (!user) {
    throw new Error('No user logged in');
  }

  try {
    // Force token refresh if it's close to expiring
    const token = await user.getIdToken();
    return token;
  } catch (error) {
    logger.error('Error refreshing token:', error);
    throw error;
  }
};